import { Injectable, inject } from "@angular/core";
import { Language, LanguageMap } from "./language";
import { MapLanguageNamePipe } from "./map-language-name.pipe";

@Injectable({ providedIn: "root" })
export class LanguageHelper {
  private mapLanguageNamePipe = inject(MapLanguageNamePipe);

  buildLanguageMapsFromCodes(codes: Language[] | string[]): LanguageMap[] {
    if (!codes) return [];

    const languageMaps: LanguageMap[] = [];
    for (const codeOrObj of codes) {
      const code = typeof codeOrObj === "string" ? codeOrObj : codeOrObj.code;
      languageMaps.push({ code, localizedName: this.mapLanguageNamePipe.transform(code) });
    }
    return languageMaps;
  }
}
